import React, { ReactElement } from 'react';
import { Immutable, safeRest } from '@wds/utils';
import { useHeaderTheme } from '../../theme';
import { VariantComponent } from '../../variants';

import useStyles from './useStyles';

export type ActionsProps = Immutable<{
  items: VariantComponent;
}>;

const Actions = ({ items, ...rest }: ActionsProps): ReactElement => {
  const theme = useHeaderTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.actions} {...safeRest(rest)}>
      {items}
    </div>
  );
};

export default Actions;
export { Actions };
